import PaymentProcessCard, { PaymentSectionDataProps } from "@components/integration/PaymentProcessCard";
import PaymentStepsAccordion, { PaymentProcess } from "@components/integration/PaymentStepsAccordion";
import AwardsSection from "@components/new-ui/AwardsSection";
import CaseStudyFeatureSection, { Feature } from "@components/new-ui/CaseStudyFeatureSection";
import ClientLogos from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FAQSection, { FAQSectionProps } from "@components/new-ui/FAQSection";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import Herosection, { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import ProductSection, { Product } from "@components/new-ui/IndustriesSection/ProductSection";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import React from "react";

const herosectionData: HerosectionProps = {
    chipTitle: "",
    title: "WhatsApp Payment Automation solutions",
    description: "Automate payment reminders, generate one-click payment links, and send instant invoices — all within WhatsApp. ",
    primaryButtonText: "Start Free Trial",
    imageUrl: "https://assets.gallabox.com/gb-home/payment/payment-automation-solution.png",
};

const featureInfo1: FeatureInfo = {
    mainTitle: "Close deals instantly with branded, frictionless payment links",
    subtitle: "Convert prospects to paying customers without leaving WhatsApp",
    imageUrl: "https://assets.gallabox.com/gb-home/payment/payment-link.png",
    featureInfoList: [
        "Boost trust with branded links tailored to your business.",
        "Create payment links instantly for bookings, bots, or campaigns",
        "Turn your WhatsApp catalog into a storefront with embedded “Pay now” buttons.",
    ],
};

const featureInfo2: FeatureInfo = {
    mainTitle: "Automated payment workflows",
    subtitle: "Eliminate manual follow-ups while keeping interactions personal and timely.",
    imageUrl: "https://assets.gallabox.com/gb-home/payment/payment-workflows.png",
    featureInfoList: [
        "Trigger reminders, invoices, refunds, and status updates automatically.",
        "Design workflows with drag-and-drop ease (e.g., “Send invoice after confirmation”).",
        "Keep customers and teams in sync with automated, real-time payment confirmations.",
    ],
};

const featureInfo3: FeatureInfo = {
    mainTitle: "Speed up cash flow with AI-powered nudges",
    subtitle: "Turn overdue payments into on-time deposits without sounding pushy.",
    imageUrl: "https://assets.gallabox.com/gb-home/payment/ai-powered.png",
    featureInfoList: [
        "Send polished invoices directly in chat post-purchase.",
        "Use AI to craft friendly, localized nudges in 100+ languages.",
        "Design collection workflows with rich media and formulas (no coding!).",
    ],
};

const featureInfo4: FeatureInfo = {
    mainTitle: "Connect seamlessly with tools your business trusts",
    subtitle: "Work with payment gateways, UPI, and custom gateways — no tech headaches.",
    imageUrl: "https://assets.gallabox.com/gb-home/payment/integrate.png",
    featureInfoList: [
        "Tap into India’s favorite payment method (UPI) with one-click integration.",
        "Share secure, trusted payment links instantly.",
        "Track payments, refunds, and workflows from a single screen.",
    ],
};

const paymentProductCardData: Array<Product> = [
    {
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/security.png",
        title: "Security with UPI PIN protection",
        description:
            "Every transaction requires a UPI PIN, and WhatsApp never stores your card or payment details. Funds move directly between bank accounts via trusted partners like BHIM UPI, ensuring compliance and peace of mind.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/bank.png",
        title: "One-time bank account setup",
        description:
            "Link your bank account once to send/receive money seamlessly via WhatsApp. No repeated logins or app-switching — just fast, UPI-powered transfers for you and your customers.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/unified-payment.png",
        title: "Unified payment tracking in chat",
        description:
            "View payment confirmations, transaction histories, and refund statuses directly in the chat thread. Keep financial records organized without jumping between apps or dashboards.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/wallet-card.png",
        title: "Frictionless in-chat purchases",
        description:
            "Customers pay instantly within WhatsApp—no redirects to third-party apps. Share payment links mid-conversation and close deals in seconds, and boosting conversion rates. ",
    },

    {
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/inbox-messages.png",
        title: "24/7 payment support and automation",
        description:
            "Resolve billing queries, send reminders, and process refunds without manual effort. AI-driven workflows handle repetitive tasks, freeing your team for high-value interactions.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/global-reaach.png",
        title: "Global reach with localized trust",
        description:
            "Tap into WhatsApp’s 3B+ users worldwide while dominating regional markets (like India via UPI). Offer secure, localized payment experiences that build credibility and loyalty.",
    },
];

const caseStudyFeatureCardData: Array<Feature> = [
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/payment/hugg.png",
        chiptitle: "D2C",
        title: "Maximizing Conversions and Streamlining Support: Hugg's Transformation with Gallabox",
        statsInfoData: [
            { percentage: "37%", label: "Improvement in Click-to-WhatsApp ads" },
            { percentage: "30%", label: "Increase in conversion rates for first-time customers" },
            { percentage: "20%", label: "Growth in number of orders after using Gallabox flows" },
        ],
        url: "/case-study/hugg",
    },
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/case-study/alrannan-admin-service.png",
        chiptitle: "SERVICE",
        title: "How Alrannan Administrative Services automated sales with Gallabox",
        statsInfoData: [
            { percentage: "45%", label: "Projected quarterly business growth" },
            { percentage: "10%", label: "Increase in team productivity" },
            { percentage: "30%", label: "Growth in customer base" },
        ],
        url: "/case-study/alrannan-administrative-services",
    },
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/payment/numberwale.png",
        chiptitle: "SERVICE",
        title: "Numberwale increases their sales by nearly 25% with the help of Gallabox.",
        statsInfoData: [
            { percentage: "25%", label: "Increase in sales" },
            { percentage: "47%", label: "Targeted campaigns to customers" },
            { percentage: "31%", label: "Quality customer service" },
        ],
        url: "/case-study/numberwale",
    },
];

const faqData: FAQSectionProps = {
    title: "FAQs for WhatsApp Payment Automation solutions",
    faqItems: [
        {
            question: "How does WhatsApp payment automation work with existing tools?",
            answer: "Automate WhatsApp payments with Gallabox’s Ask Payments. Link your account, create payment requests via providers (payment gateways/UPI), add order details, product images, and personalized notes. Customize taxes, discounts, or shipping in advanced settings. Set fallback actions for off-topic replies to maintain chat flow. Share tailored payment links directly in chats, enabling seamless collections without app-switching. Simplify transactions, boost efficiency.",
        },
        {
            question: "What payment methods are supported via WhatsApp payment links?",
            answer: (
                <>
                    <>
                        Send WhatsApp payment links:
                        <li>Conversations &gt; Select contact &gt; Send payment request. </li>
                        <li>Enter amount, reason, provider (UPI/Razorpay).</li>
                        <li>Link delivered instantly.</li>
                    </>
                    <>Providers: UPI & Razorpay. Use Send/Ask Payments cards for in-chat collections. Streamline transactions, no app-switching.</>
                </>
            ),
        },
        {
            question: "Is coding required to set up automated payment workflows?",
            answer: "Automating payment workflows doesn’t require coding. Use Gallabox’s dashboard to select pre-built workflows (e.g., payment notifications), choose a message template, map variables like customer details or payment amount, and submit. Configure settings for Cashfree or Stripe integrations to automate reminders, invoices, or refunds — all directly within WhatsApp.",
        },
        {
            question: "Can I integrate Razorpay directly into WhatsApp conversations?",
            answer: "Yes! Integrate Razorpay with WhatsApp via Gallabox: Auto-generate & share payment links via chatbot, merging Razorpay’s security with WhatsApp’s reach. Customers pay in-chat. Code-free setup in dashboard.",
        },
        {
            question: "How do payment reminders work without annoying customers?",
            answer: (
                <>
                    <>
                        Gallabox ensures gentle, personalized reminders:
                        <li>Schedule alerts (e.g., 3-day pre-due) only when needed.</li>
                        <li>Use friendly, customizable templates with invoice details.</li>
                        <li>Automate confirmations post-payment to avoid over-messaging.</li>
                    </>
                    <>Balances timely nudges with respect for customer experience.</>
                </>
            ),
        },
        {
            question: "Can I automate refund updates through WhatsApp?",
            answer: "Automate refund updates through WhatsApp using Gallabox’s CRM  integration. Activate the Order Refunded Workflow: link your store, select the workflow, choose a WhatsApp template, map variables (order details, refund amount), and submit. The system auto-sends notifications when refunds are processed—no coding needed.",
        },
        {
            question: "Does the solution support service bookings and catalog integration?",
            answer: "Yes, Gallabox supports catalog integration by syncing your Facebook Catalog. Showcase products directly in WhatsApp chats, allowing customers to browse and place orders without leaving the conversation. Enable seamless product discovery and purchasing within the chat flow.",
        },
        {
            question: "Is the free trial truly credit-card-free and time-limited?",
            answer: "Gallabox’s free trial lasts 7 days and requires no credit card. It provides full access to all features (e.g., chatbots, automations) and includes free conversation credits. There are no hidden fees; the trial ends automatically unless you opt to upgrade.",
        },
        {
            question: "How secure are payment transactions handled via WhatsApp?",
            answer: "Gallabox secures WhatsApp payments via its “Send Payments” feature, using trusted providers like UPI and Razorpay. Transactions are protected with HTTPS encryption, multi-factor authentication, and strict access controls. The platform adheres to industry standards to ensure data confidentiality and compliance, letting businesses share payment links safely within chats.",
        },
    ],
};

const paymentSectionData: PaymentSectionDataProps[] = [
    {
        imageUrl: "https://assets.gallabox.com/gb-home/payment/payment-solution.gif",
        title: "Access payment gateway settings",
        description: "Head over to the “Configure Payment Gateway” section in your Gallabox dashboard. Click Connect next to “WhatsApp Pay” to open the setup window.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/payment/payment-solution.gif",
        title: "Link your WhatsApp Business account",
        description:
            "Select the WhatsApp channel (Indian number connected to Gallabox) and enter the payment configuration name exactly as it appears in your Meta Business Suite.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/payment/payment-solution.gif",
        title: "Select payment provider and enter credentials",
        description:
            "Choose your preferred provider (e.g., RazorPay) and input the configuration name used in WhatsApp Business Manager. Double-check UPI IDs or API keys for accuracy.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/payment/payment-solution.gif",
        title: "Save and enable milti-gateway support",
        description:
            "Click Save to activate WhatsApp Pay. Repeat to add other providers (e.g., PayU for credit cards, UPI for instant transfers) and switch between them effortlessly.",
    },
];

const defaultFAQData: PaymentProcess = {
    title: "How to get started with WhatsApp Payment Automation solutions",
    description: "To get started with the WhatsApp Payment Automation solutions feature in Gallabox, follow these steps:",
    ProcessSteps: [
        {
            imageUrl: "https://assets.gallabox.com/gb-home/payment/payment-solution.gif",
            title: "Access payment gateway settings",
            description: "Head over to the “Configure Payment Gateway” section in your Gallabox dashboard. Click Connect next to “WhatsApp Pay” to open the setup window.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/payment/payment-solution.gif",
            title: "Link your WhatsApp Business account",
            description:
                "Select the WhatsApp channel (Indian number connected to Gallabox) and enter the payment configuration name exactly as it appears in your Meta Business Suite.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/payment/payment-solution.gif",
            title: "Select payment provider and enter credentials",
            description:
                "Choose your preferred provider (e.g., RazorPay) and input the configuration name used in WhatsApp Business Manager. Double-check UPI IDs or API keys for accuracy.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/payment/payment-solution.gif",
            title: "Save and enable milti-gateway support",
            description:
                "Click Save to activate WhatsApp Pay. Repeat to add other providers (e.g., PayU for credit cards, UPI for instant transfers) and switch between them effortlessly.",
        },
    ],
};

const WhatsappPayment: React.FC = () => {
    return (
        <NewLayout
            description="Automate transactions with WhatsApp Payment Automation solutions. Send invoices, process payments, and enhance customer experience."
            title="Whatsapp Payment Automation solutions | Fast & Secure"
            canonical="https://gallabox.com/whatsapp-payment"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/payment/payment-og.png" }}
            schema={{
                heroOrOgImageAlt: "whatsapp-payments-image",
                heroOrOgImageDescription: "WhatsApp Payment Automation solutions",
                heroOrOgImageUrl: "https://assets.gallabox.com/gb-home/whatsapp-shared-inbox/shared-team-inbox-hero-image.png",
                softwareFeatureName: "whatsapp-payments",
                faq: faqData.faqItems,
                howTo: { howtoSteps: defaultFAQData.ProcessSteps },
            }}
        >
            <Herosection herosection={herosectionData} />
            <section className={`${container_classname} my-10`}>
                <h3 className="text-center text-lg font-normal py-5">TRUSTED BY 10,000+ BUSINESSES</h3>
                <ClientLogos />
            </section>

            <h2 className="md:text-6xl text-4xl font-semibold pb-10 max-w-7xl mx-auto px-5" style={{ fontFamily: "Degular Display" }}>
                Convert engaging prospects to paying customers with WhatsApp Payment Automation solutions
            </h2>
            <FeatureInfoCard {...featureInfo1} />
            <FeatureInfoCard {...featureInfo2} />
            <FeatureInfoCard {...featureInfo3} />
            <FeatureInfoCard {...featureInfo4} removeDivider />

            <ProductSection
                productCardData={paymentProductCardData}
                title="Benefits of using WhatsApp Payment Automation solutions"
                description="Cement your prospect relationships with Gallabox’s user-friendly features"
                gridCols="md:grid-cols-3"
            />

            <PaymentProcessCard
                title="How to get started with WhatsApp Payment Automation solutions"
                description="To get started with the WhatsApp Payment Automation solutions feature in Gallabox, follow these steps:"
                paymentSectionData={paymentSectionData}
                backgroundColor="white"
            />

            <PaymentStepsAccordion paymentStepsData={defaultFAQData} />
            <div className="mt-20">
                <CaseStudyFeatureSection features={caseStudyFeatureCardData} />
            </div>

            <FAQSection faqData={faqData} />
            <IntegrationSection isLight={true} />
            <AwardsSection />
            <CTASection title="Integrate WhatsApp with your Facebook Ads today" primaryButtonText="Get free trial" />
        </NewLayout>
    );
};

export default WhatsappPayment;
